module.exports = __webpack_public_path__ + "static/img/37.9e08839.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/37.png
// module id = GkTH
// module chunks = 1